import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2, _path3, _path4;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgTheme = function SvgTheme(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M16.546 2.66H3.455c-.682 0-1.228.545-1.228 1.226v12.228c0 .681.546 1.227 1.228 1.227h13.09c.682 0 1.228-.546 1.228-1.227V3.886c0-.681-.546-1.227-1.227-1.227ZM14.11 2.66v14.636M17.49 7.205h-3.38",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeMiterlimit: 10
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "m5.609 12.762 2-4.633.349-.814a.14.14 0 0 1 .25 0l2.5 5.447",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M9.247 10.637H6.973",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeMiterlimit: 10,
      strokeLinecap: "square"
    })), _path4 || (_path4 = /*#__PURE__*/_jsx("path", {
      d: "M6.859 12.762H4.735M11.581 12.762H9.457",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    }))]
  }));
};
export default SvgTheme;